'use client';
import { useEffect, useState, useRef } from 'react';
import { usePathname } from 'next/navigation';
import styles from '@/components/header/HeaderClient.module.scss';
import isEmpty from 'lodash/isEmpty';
import Link from 'next/link';
import NextImage from 'next/image';
import logoBigSrc from '@/public/assets/logo-big.png';
import get from 'lodash/get';
import Image from '@/grandus-utils/wrappers/image/Image';
import logoSrc from '@/public/assets/logo-big.png';

const HeaderClient = ({ children, webInstance }) => {
  const path = usePathname();
  const [isFullHeader, setIsFullHeader] = useState(path === '/');
  const ticking = useRef(false);

  const logo = get(webInstance, 'logo');
  const logoClassNames = "mx-auto animate-flip-in will-change-transform [backface-visibility:hidden]";

  useEffect(() => {
    if (path !== '/') {
      return;
    }
    const onScroll = () => {
      // rAF throttle for smooth, low-cost updates
      if (!ticking.current) {
        ticking.current = true;
        window.requestAnimationFrame(() => {
          const y = window.scrollY || window.pageYOffset || 0;
          setIsFullHeader(y < 30);

          ticking.current = false;
        });
      }
    };

    // Initial run (in case user lands mid-page)
    onScroll();

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [path]);

  return (
    <header
      className={`${styles.header} ${isFullHeader ? 'dark ' : 'bg-beige'}`}
    >
      <div
        className="relative
          dark:bg-gradient-to-b dark:from-black dark:to-transparent dark:h-[450px]"
      >
        <div className="container">
          {/* Navigation */}
          <nav className="relative z-20 w-full dark:pt-10">
            <div className={'mb-[44px] hidden lg:dark:block'}>
              <Link href={'/'}>
                {logo
                  ? <Image photo={logo} alt="lides" height={70} width={300} type="png" className={`aspect-[300/70] ${logoClassNames}`} />
                  : <NextImage src={logoBigSrc} alt={''} width={300} className={logoClassNames} />
                }
              </Link>
            </div>
            {children}
          </nav>
        </div>
      </div>
    </header>
  );
};

export default HeaderClient;
